// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W5LbSWL69cx_XCrJKP6X{gap:8px;margin-top:12px;display:flex}.MIzd_2KdlVA4tEp33JlG{margin-top:24px;margin-bottom:-8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `W5LbSWL69cx_XCrJKP6X`,
	"alert": `MIzd_2KdlVA4tEp33JlG`
};
export default ___CSS_LOADER_EXPORT___;
